<script setup lang="tsx">
import { onMounted, onUnmounted, ref } from "vue";
import { getCSSVar, injectStyle } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: getCSSVar("--yz-xg-blue", "#5a82f0")
  }
);

const loading7 = ref();

onMounted(() => {
  /// for ce
  injectStyle(
    `
  :root {
    --loading-7-bg-color: ${props.color}
  }
  :host {
    --loading-7-bg-color: ${props.color}
  }
  `,
    loading7.value
  );
});

onUnmounted(() => {});
</script>

<template>
  <div
    class="loading-7"
    ref="loading7"
  >
    <div></div>
  </div>
</template>

<style scoped>
.loading-7 {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.loading-7 > div {
  width: 50%;
  height: 50%;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.loading-7 > div::before {
  content: "";
  width: 100%;
  height: 5px;
  box-sizing: border-box;
  background: #000;
  opacity: 0.1;
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  border-radius: 50%;
  animation: shadow 0.5s linear infinite;
}
.loading-7 > div::after {
  content: "";
  width: 100%;
  height: 100%;
  animation: animate 0.5s linear infinite;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 3px;
  background-color: var(--loading-7-bg-color);
}
@keyframes animate {
  17% {
    border-bottom-right-radius: 3px;
  }
  25% {
    transform: translateY(9px) rotate(22.5deg);
  }
  50% {
    transform: translateY(18px) scale(1, 0.9) rotate(45deg);
    border-bottom-right-radius: 40px;
  }
  75% {
    transform: translateY(9px) rotate(67.5deg);
  }
  100% {
    transform: translateY(0) rotate(90deg);
  }
}

@keyframes shadow {
  0%,
  100% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1);
  }
}
</style>
